var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTurkey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "2814.614 319.769 449.993 439.144",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1",
    style: {},
    transform: "matrix(-1.033817, 0, 0, 1, 6200.824707, -0.737352)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 225,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "currentColor",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 30031.601563 16022.382813 C 30031.601563 16022.382813 30198.984375 16247.695313 30293.710938 16363.59375 C 29025.703125 16500.390625 28704.21875 17131.601563 28704.21875 17649.492188 C 28704.21875 17962.1875 28925.3125 18323.59375 29023.515625 18493.28125 C 29121.71875 18662.890625 29182.617188 18888.085938 29047.5 18928.90625 C 28915 18968.90625 28632.1875 18969.296875 28632.1875 18969.296875 C 28632.1875 19198.984375 28898.28125 19303.90625 28898.28125 19303.90625 C 28830.3125 19528.90625 29007.1875 19851.992188 29373.984375 19851.992188 C 29655.3125 19851.992188 29902.109375 19647.695313 29928.710938 19397.695313 C 29947.382813 19222.304688 29800.195313 18880.3125 29835 18718.007813 C 29863.59375 18583.984375 30088.203125 18462.617188 30198.984375 18403.90625 C 30444.492188 18273.90625 31230.3125 18091.40625 31230.3125 18091.40625 C 31230.3125 18091.40625 30880.3125 17497.695313 30448.984375 17416.40625 C 30261.09375 17381.015625 29698.984375 17566.40625 29698.984375 17566.40625 ",
    transform: "matrix(0.1,0,0,-0.1,0,2340)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 225,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      stroke: "currentColor",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 30302.8125 18357.617188 L 31493.710938 19996.09375 C 31493.710938 19996.09375 32567.8125 19228.90625 32567.8125 18225.78125 C 32567.8125 17222.695313 31733.398438 16294.492188 31639.6875 16172.695313 C 31564.6875 16247.695313 31058.398438 16613.28125 31058.398438 16613.28125 L 30448.984375 16003.90625 ",
    transform: "matrix(0.1,0,0,-0.1,0,2340)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 225,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "currentColor",
      strokeOpacity: 1,
      strokeMiterlimit: 5
    },
    d: "M 29628.789063 16003.90625 L 30997.382813 16003.90625 ",
    transform: "matrix(0.1,0,0,-0.1,0,2340)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 225,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "currentColor",
      strokeOpacity: 1,
      strokeMiterlimit: 5
    },
    d: "M 32507.8125 18010.195313 L 31814.6875 18010.195313 ",
    transform: "matrix(0.1,0,0,-0.1,0,2340)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 225,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "currentColor",
      strokeOpacity: 1,
      strokeMiterlimit: 5
    },
    d: "M 32158.59375 19240.585938 L 31623.398438 18705.507813 ",
    transform: "matrix(0.1,0,0,-0.1,0,2340)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 225,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "currentColor",
      strokeOpacity: 1,
      strokeMiterlimit: 5
    },
    d: "M 32083.59375 16854.6875 L 31623.398438 17314.804688 ",
    transform: "matrix(0.1,0,0,-0.1,0,2340)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "currentColor",
      fillOpacity: 1
    },
    d: "M 2943.96875 394.421875 C 2943.96875 402.699219 2937.25 409.421875 2928.96875 409.421875 C 2920.679688 409.421875 2913.96875 402.699219 2913.96875 394.421875 C 2913.96875 386.128906 2920.679688 379.421875 2928.96875 379.421875 C 2937.25 379.421875 2943.96875 386.128906 2943.96875 394.421875 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurkey);
export default __webpack_public_path__ + "static/media/turkey.6d3736c9.svg";
export { ForwardRef as ReactComponent };